import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4d4ab8e&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4d4ab8e')) {
      api.createRecord('a4d4ab8e', component.options)
    } else {
      api.reload('a4d4ab8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a4d4ab8e&lang=pug", function () {
      api.rerender('a4d4ab8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/arcsModal/index.vue"
export default component.exports